const moneyFormat = '${{amount}}';

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney$1(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

var formatMoney = (function (val) {
  return formatMoney$1(val, window.theme.moneyFormat || "${{amount}}");
});


/* App BundleProducts */
class BundleProducts extends HTMLElement {
  constructor() {
    super();
    this.bundleTotal = 0;
    this.pourcentageDiscount = 0;
    this.cartButton = null; // Le bouton pour ajouter au panier
    this.quickCartSelector = '[data-quick-cart]'; // Sélecteur pour le quick-cart
    this.purchaseConfirmationSelector = '[data-purchase-confirmation]'; // Sélecteur pour la popup de confirmation
  }

  connectedCallback() {
    this.querySelectorAll('.custom-dropdown').forEach((dropdown) => {
      this.initializeDropdown(dropdown);
    });

    this.cartButton = this.querySelector('[data-add-to-cart]'); // Le bouton "Ajouter au panier"

    // Ajouter un événement pour le bouton "Ajouter au panier"
    this.cartButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.addBundleToCart();
    });

    // Calculer le prix total de départ
    this.calculateBundleTotal();
  }

  // Méthode pour initialiser un dropdown stylisé
  initializeDropdown(dropdown) {
    const dropdownTrigger = dropdown.querySelector('.dropdown-trigger');
    const dropdownOptions = dropdown.querySelector('.dropdown-options');
    const dropdownSelected = dropdown.querySelector('.dropdown-selected');
    const hiddenSelect = dropdown.closest('.bundle__product').querySelector('.hidden-select');
    const priceContainer = dropdown.closest('.bundle__product').querySelector('.bundle-variant-price');

    // Ouvrir/Fermer le dropdown
    dropdownTrigger.addEventListener('click', () => {
      dropdownTrigger.parentElement.classList.toggle('dropdown-active');
    });

    // Gérer la sélection d'une option
    dropdown.querySelectorAll('.dropdown-option').forEach((option) => {
      option.addEventListener('click', () => {
        const variantId = option.getAttribute('data-variant-id');
        const variantTitle = option.getAttribute('data-variant-title');
        const variantPrice = option.getAttribute('data-variant-price');

        dropdownSelected.closest('details').querySelector('summary span').innerHTML = variantTitle;

        // Mettre à jour le texte sélectionné
        dropdownSelected.innerHTML = `${variantTitle} - ${formatMoney(variantPrice)}`;

        // Mettre à jour la valeur du select caché
        hiddenSelect.value = variantId;

        priceContainer.innerHTML = formatMoney(variantPrice);

        // Fermer le dropdown
        dropdownTrigger.parentElement.classList.toggle('dropdown-active');
        dropdownSelected.closest('details').removeAttribute('open');

        // Mettre à jour le prix du bundle
        this.updateProductPrice(dropdown, variantPrice);
      });
    });
  }

  // Méthode pour calculer le total initial des produits dans le bundle
  calculateBundleTotal() {
    this.bundleTotal = 0;

    this.querySelectorAll('.bundle__product').forEach((product) => {
      const productPrice = parseFloat(product.dataset.price);
      this.bundleTotal += productPrice;
    });

    this.applyDiscount();
    this.updateTotalDisplay();
  }

  // Méthode pour appliquer la réduction
  applyDiscount() {
    this.pourcentageDiscount = parseFloat(this.querySelector('[data-save]').dataset.save) || 0;
    const discountMultiplier = 1 - this.pourcentageDiscount / 100;
    this.bundleTotal *= discountMultiplier;
  }

  // Méthode pour mettre à jour le prix d'un produit après sélection d'une variante
  updateProductPrice(dropdown, newPrice) {
    const product = dropdown.closest('.bundle__product');
    product.setAttribute('data-price', newPrice);

    this.calculateBundleTotal();
  }

  // Mettre à jour l'affichage du prix total
  updateTotalDisplay() {
    const totalDisplay = this.querySelector('.bundle_products_total');
    if (totalDisplay) {
      totalDisplay.innerHTML = window.formatMoney(this.bundleTotal); // Ajuster selon la devise utilisée
    }
  }

  // Ajouter les produits du bundle au panier via l'API du panier de Shopify
  addBundleToCart() {
    const itemsToAdd = [];

    // Obtenir les produits du bundle et les variantes sélectionnées
    this.querySelectorAll('.bundle__product').forEach((product) => {
      const variantId = product.querySelector('.hidden-select').value;
      itemsToAdd.push({
        id: variantId,
        quantity: 1 // ou tout autre nombre selon la logique du bundle
      });
    });

    // Afficher le bouton de chargement pendant l'ajout
    this.setLoadingState(true);

    // Envoyer les produits à l'API du panier Shopify
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: itemsToAdd })
    })
      .then((response) => response.json())
      .then((data) => {
        // Désactiver l'état de chargement
        this.setLoadingState(false);
        console.log('Produits ajoutés au panier:', data.items);

        // Ouvrir le quick cart et le rafraîchir
        const event = new CustomEvent('cart:item-added', {
          detail: { items: data.items } // Inclure les items ajoutés dans le détail de l'événement
        });
        document.dispatchEvent(event);

      })
      .catch((error) => {
        console.error('Erreur lors de l\'ajout au panier:', error);
        this.setLoadingState(false);
        // Gérer l'affichage des erreurs
        this.showErrorMessage(error);
      });
  }

  // Activer ou désactiver l'état de chargement
  setLoadingState(isLoading) {
    if (isLoading) {
      this.cartButton.classList.add('loading');
    } else {
      this.cartButton.classList.remove('loading');
    }
  }

  // Gérer l'affichage des erreurs d'ajout au panier
  showErrorMessage(error) {
    const errorMessage = this.querySelector('.cart-error-message');
    errorMessage.textContent = error.message || 'Une erreur est survenue lors de l\'ajout au panier.';
    errorMessage.classList.remove('hidden');
  }
}

// Déclarer le custom element
customElements.define('bundle-products', BundleProducts);
